import { type DatasourceResponseSchemaProperty } from '@atlaskit/linking-types';
import { type CloudId } from '@databases/types/confluence';
import { type AnyAction } from 'redux';
import { type ThunkAction } from 'redux-thunk';

import {
  DatasourceService,
  type DatasourceType
} from '@canvas/atlassian-service/datasource';

import { serializeError } from '../../utils';
import { type CommonRootState, loadAsync } from '../redux';

import { selectSupportedProperties, selectSupportedPropertiesStatus } from './selectors';
import datasourcesSlice from './slice';

type Dispatcher<Result> = ThunkAction<Result, CommonRootState, void, AnyAction>;

export const loadSupportedFields =
  (
    cloudId: CloudId,
    datasourceType: DatasourceType
  ): Dispatcher<Promise<DatasourceResponseSchemaProperty[] | undefined>> =>
  async (dispatch, getState) => {
    await loadAsync(
      () => selectSupportedPropertiesStatus(getState(), cloudId, datasourceType),
      () => {
        dispatch(
          datasourcesSlice.actions.loadSupportedPropertiesPending({
            cloudId,
            datasourceType
          })
        );
      },
      async () =>
        await new DatasourceService(datasourceType).getSupportedProperties({
          parameters: { cloudId }
        }),
      (supportedProperties) => {
        dispatch(
          datasourcesSlice.actions.loadSupportedPropertiesFinished({
            cloudId,
            datasourceType,
            supportedProperties
          })
        );
      },
      (error) => {
        dispatch(
          datasourcesSlice.actions.loadSupportedPropertiesError({
            cloudId,
            datasourceType,
            error: serializeError(error)
          })
        );
      }
    );

    return selectSupportedProperties(getState(), cloudId, datasourceType);
  };
